(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.tvPx = _exports.tv = _exports.tabletPx = _exports.tablet = _exports.reducedMotion = _exports.phabletPx = _exports.phablet = _exports.lapPx = _exports.lap = _exports.hdpi = _exports.deskPx = _exports.desk = void 0;

  /*
   |------------------------------------------------------------------------------
   | Resolution
   |------------------------------------------------------------------------------
   */

  var hdpi = "@media only screen and (-moz-min-device-pixel-ratio: 1.5),\n  only screen and (-o-min-device-pixel-ratio: 3/2),\n  only screen and (-webkit-min-device-pixel-ratio: 1.5),\n  only screen and (min-device-pixel-ratio: 1.5)";

  /*
   |------------------------------------------------------------------------------
   | Breakpoints
   |------------------------------------------------------------------------------
   */
  _exports.hdpi = hdpi;
  var phablet = "@media only screen and (min-width: 37.5rem)"; /* 600px */
  _exports.phablet = phablet;
  var phabletPx = 600;
  _exports.phabletPx = phabletPx;
  var tablet = "@media only screen and (min-width: 50rem)"; /* 800px */
  _exports.tablet = tablet;
  var tabletPx = 800;
  _exports.tabletPx = tabletPx;
  var lap = "@media only screen and (min-width: 75rem)"; /* 1200px */
  _exports.lap = lap;
  var lapPx = 1200;
  _exports.lapPx = lapPx;
  var desk = "@media only screen and (min-width: 87.5rem)"; /* 1400px */
  _exports.desk = desk;
  var deskPx = 1400;
  _exports.deskPx = deskPx;
  var tv = "@media only screen and (min-width: 100rem)"; /* 1600px */
  _exports.tv = tv;
  var tvPx = 1600;

  /*
   |------------------------------------------------------------------------------
   | Accessibility
   |------------------------------------------------------------------------------
   */
  _exports.tvPx = tvPx;
  var reducedMotion = "@media (prefers-reduced-motion: reduce)";
  _exports.reducedMotion = reducedMotion;
});